import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-identification-method',
  templateUrl: './identification-method.component.html',
  styleUrls: ['./identification-method.component.scss']
})
export class IdentificationMethodComponent implements OnInit {
  hashKey: string;
  tenantId: string;
  contractIdAndContractEnterpriseIdEncode: string = null;
  constructor(
    private router: ActivatedRoute,
    private route: Router,
  ) { 
    this.router.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
  }

  ngOnInit() {
  }

  onIdentificationOtp() {
    console.log('this.contractIdAndContractEnterpriseIdEncode', this.contractIdAndContractEnterpriseIdEncode)
    if(this.contractIdAndContractEnterpriseIdEncode) {
      this.route.navigate([`kyc-customer-identify/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`]);
    } else {
      this.route.navigate([`kyc-customer-identify/${this.hashKey}/${this.tenantId}`]);
    }
  }

  onBack() {
    if(this.contractIdAndContractEnterpriseIdEncode) {
      this.route.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`]);
    } else {
      this.route.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}`]);
    }
  }

  onConfirm() {
    if(this.contractIdAndContractEnterpriseIdEncode) {
      this.route.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`]);
    } else {
      this.route.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`]);
    }

  }


}
